import React from "react";
import s from './HeaderQuestion.module.scss';

const HeaderQuestion = ({questionName, isRequired}) => (
  <p className={s.singleTitle}>{questionName} {isRequired && <sup>*</sup>}</p>
);
export default HeaderQuestion;
